import React, { Component } from 'react';
import MaterialOption from './MaterialOption';

class MaterialSelector extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: props.value || {
                label: '',
                value: ''
            }
        };
        this._onClick = this._onClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.selected) {
            this.setState({ selected: newProps.value });
        } else if (!newProps.value) {
            this.setState({
                selected: {
                    label: '',
                    value: ''
                }
            });
        }
    }

    setValue(value) {
        let newState = {
            selected: value
        };
        this.fireChangeEvent(newState);
        this.setState(newState);
    }

    fireChangeEvent(newState) {
        if (newState.selected !== this.state.selected && this.props.onChange) {
            this.props.onChange(newState.selected);
        }
    }

    _onClick(event, value) {
        this.setValue(value);
    }

    render() {
        return (
            <div className="RadioGroup">
                {!this.props.label ? null : <span className="RadioGroup-title">{this.props.label}</span>}
                <div>
                    {this.props.options.map(option => <MaterialOption value={option} onClick={this._onClick} checked={this.state.selected && option.value === this.state.selected.value} key={option.value} />)}
                </div>
            </div>
        );
    }
}

export default MaterialSelector;


// WEBPACK FOOTER //
// ./src/MaterialSelector.js